import {Card, H5} from "@blueprintjs/core";
import * as React from "react";

type LabeledCardProps = React.PropsWithChildren<{
    label: React.ReactNode;
}>;

export const LabeledCard: React.FC<LabeledCardProps> = (props) => (
    <div style={{marginBottom: "20px"}}>
        <Card>
            <H5>{props.label}</H5>

            {props.children}
        </Card>
    </div>
);
